import React, { Component } from 'react'
import styled from 'styled-components'
import { sendAppDownload } from '../../../rest'
import { InputContainer } from '../components/styles/form'
import { CtaBtn } from '../../../components'
import DemoPhone from '../../../lib/assets/icons/phone-suki-app.png'
import {
  ROUTES
} from '../../../lib'
import InputMask from 'react-input-mask'
import Success from '../Success'
import { BREAKPOINT } from '../constants'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin: auto;

  a {
      color: #006264;
  }

  @media (max-width: ${BREAKPOINT.MEDIUM}) {
    display:none;
  }
`

const AppContainer = styled.div`
  position:relative;
`

const InPhoneApp = styled.img.attrs({
  src: DemoPhone
})`
      width: 300px;
      margin: 0px;
      padding: 0;
      position: relative;
  `

const Title = styled.div`
 font-family: SpaceGrotesk, sans-serif;

  h1 {
    margin: 0;
    font-weight: 500;
    
  }

  h2 {
    font-size: 24px;
    margin: 0;
    font-weight: 400;
  }
`
const ContentBox = styled.div`
  background: white;
  border-radius: 0 10px 10px 0;
  width: 100%;
  padding: 40px;
  height: 400px;
  border: 1px solid rgba(130,130,130,.2);
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.08), 0 -2px 3px 0 rgba(0,0,0,0.05);

  p {
    color: rgba(0, 0, 0, 0.5);
    font-size: 12px;
    margin: 0;
  }

  h5 {
    font-size: 20px;
    font-weight: 500;
  }
`

const PhoneContainer = styled.div`
  display:flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  margin-top: 100px;

  div {
    width: 50%;
    margin-right: 20px;
    input {
      margin: 0;
    }
  }

  button {
    margin: 0;
    margin-bottom: 16px;
  }
`

const SuccessMobile = styled.div`
  display: none;

  @media (max-width: ${BREAKPOINT.MEDIUM}) {
    display: flex;
  }
`

class GetSuki extends Component {
  state = {
    phoneNumber: this.props.phoneNumber || 1,
    isSendingTextLoading: false
  }

  handlePhoneChange = e => {
    // remove mask, remove leading 1 -- kinda hacky
    const val = e.target.value.replace(/[^\d]/g, '')
    this.setState({ phoneNumber: val })
  }

  onHandleSendApp = () => {
    const { user, history } = this.props
    const { phoneNumber } = this.state
    sendAppDownload({ user, phoneNumber })
    history.push(ROUTES.REGISTER_SUCCESS)
  }

  render () {
    const { phoneNumber } = this.state
    return (
      <>
        <Container>
          <AppContainer>
            <InPhoneApp />
          </AppContainer>
          <ContentBox>
            <Title>
              <h1>Get the Suki App</h1>
              <h2>We'll send you a link to download the app.</h2>
            </Title>
            <PhoneContainer>
              <InputContainer>
                <InputMask
                  className='onboard-input'
                  type='tel'
                  name='phoneNumber'
                  placeholder='Phone Number'
                  defaultValue={phoneNumber}
                  onChange={this.handlePhoneChange}
                  mask='+1 (999) 999-9999'
                  required
                />
              </InputContainer>
              <CtaBtn disabled={phoneNumber.length !== 11} handleClick={this.onHandleSendApp}>Send me a Link</CtaBtn>
            </PhoneContainer>
            <p>Message and data rate may apply.</p>
            <h5>Or use the web version of Suki at <a href='/'>app.suki.ai</a></h5>
          </ContentBox>
        </Container>
        <SuccessMobile>
          <Success />
        </SuccessMobile>
      </>
    )
  }
}

export default GetSuki
